import { z } from 'zod';

const civilDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

export const CollaboratorAbsenceKindSchema = z.enum(['VACATION', 'SICK_LEAVE', 'ABSENCE']);

export type CollaboratorAbsenceKind = z.infer<typeof CollaboratorAbsenceKindSchema>;

export const SaveCollaboratorWorkHoursBodySchema = z.object({
  weeklyMinutes: z.number().int(),
  effectiveFrom: civilDateSchema,
});

export type SaveCollaboratorWorkHoursBody = z.infer<typeof SaveCollaboratorWorkHoursBodySchema>;

export const CollaboratorWorkHoursResponseSchema = z.object({
  placeId: z.uuid(),
  userId: z.uuid(),
  weeklyMinutes: z.number().int(),
  effectiveFrom: civilDateSchema,
});

export type CollaboratorWorkHoursResponse = z.infer<typeof CollaboratorWorkHoursResponseSchema>;

export const RecordCollaboratorAbsenceBodySchema = z.object({
  startsOn: civilDateSchema,
  endsOn: civilDateSchema,
  kind: CollaboratorAbsenceKindSchema,
});

export type RecordCollaboratorAbsenceBody = z.infer<typeof RecordCollaboratorAbsenceBodySchema>;

export const CollaboratorAbsenceResponseSchema = z.object({
  id: z.uuid(),
  placeId: z.uuid(),
  userId: z.uuid(),
  startsOn: civilDateSchema,
  endsOn: civilDateSchema,
  kind: CollaboratorAbsenceKindSchema,
});

export type CollaboratorAbsenceResponse = z.infer<typeof CollaboratorAbsenceResponseSchema>;

export const CollaboratorWorkHoursListResponseSchema = z.object({
  placeId: z.uuid(),
  userId: z.uuid(),
  vigencias: z.array(
    z.object({
      weeklyMinutes: z.number().int(),
      effectiveFrom: civilDateSchema,
    }),
  ),
  absences: z.array(CollaboratorAbsenceResponseSchema),
});

export type CollaboratorWorkHoursListResponse = z.infer<
  typeof CollaboratorWorkHoursListResponseSchema
>;

export const CollaboratorPaidMinutesQuerySchema = z.object({
  periodStart: civilDateSchema,
  periodEnd: civilDateSchema,
});

export type CollaboratorPaidMinutesQuery = z.infer<typeof CollaboratorPaidMinutesQuerySchema>;

export const CollaboratorPaidMinutesResponseSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('ABSENT') }),
  z.object({ kind: z.literal('MINUTES'), minutes: z.number().int().nonnegative() }),
]);

export type CollaboratorPaidMinutesResponse = z.infer<typeof CollaboratorPaidMinutesResponseSchema>;
